import React from 'react';
import {Alert, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../Button";
import Icon from "../../../componentsReusable/Icon";
import WarehouseDocumentLabel from "../../Warehouse/WarehouseDocument/WarehouseDocumentLabel";

const DocumentErrorsModal = (props) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);

  return <React.Fragment>
    <Icon className="fas fa-times text-danger cursor-pointer" tooltip="Kliknij, aby zobaczyć listę błędnych pozycji" onClick={toggleModalOpen} />
    {modalOpen && <Modal isOpen={modalOpen} size="lg">
      <ModalHeader toggle={toggleModalOpen}>Lista błędów dla dokumentu: {props.document.externalNumber}</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>
        <ListGroup>
          {props.document.errors.map(errorMsg => <ListGroupItem>{errorMsg}</ListGroupItem>)}
        </ListGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>Zamknij</Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>
}

const SynchronizedInfo = ({synchronized}) => {
  return synchronized.map(synch => {
    let headerColor = synch?.completed ? 'success' : 'primary';
    const created = synch?.completed ? synch?.result?.documents?.filter(d => d.created).length : 0
    const updated = synch?.completed ? synch?.result?.documents?.filter(d => d.updated).length : 0
    const createdProducts = synch?.completed ? synch?.result?.products.length : 0
    const error = synch?.completed ? synch?.result?.documents?.filter(d => d.errors.length > 0).length : 0

    if(error > 0){
      headerColor = 'danger';
    }

    return <ListGroup className="mb-2">
      <ListGroupItem className="d-flex justify-content-between align-items-center" color={headerColor}>
        <span>{synch.key}</span>

        {synch.completed && <div>
          {error > 0 && <span className="text-danger">
            <Icon className="fas fa-times mr-1" tooltip="Błędne dokumenty" />
            <span>{error}</span>
          </span>}
          {updated > 0 && <span className="ml-3 text-success">
            <Icon className="fas fa-edit mr-1" tooltip="Zaktualizowane dokumenty" />
            <span>{updated}</span>
          </span>}
          {created > 0 && <span className="ml-3 text-success">
            <Icon className="fas fa-plus mr-1" tooltip="Utworzone dokumenty" />
            <span>{created}</span>
          </span>}
          {createdProducts > 0 && <span className="ml-3 text-success">
            <Icon className="fa fa-dolly-flatbed mr-1" tooltip="Utworzone nowe towary (bez przyjęcia magazynowego)" />
            <span>{createdProducts}</span>
          </span>}
        </div>}
      </ListGroupItem>
      {
        !synch.completed
          ? <ListGroupItem className="text-center">Trwa import...</ListGroupItem>
          : <React.Fragment>
            {
              synch?.result?.documents?.length > 0
                ? <ListGroupItem>
                  <div className="d-flex flex-column">
                    {synch?.result?.documents?.map((document, key) => {
                      return <div className="d-flex flex-row" key={key}>
                              <span className="d-block text-center" style={{width: '20px'}}>
                                {(document.created || document.updated) && <i className="fas fa-check-circle text-success"/>}
                                {document.errors.length > 0 && <React.Fragment>
                                  <DocumentErrorsModal document={document} />
                                </React.Fragment>}
                              </span>
                        <div className="d-flex flex-row align-items-center ml-2">
                          {
                            document.document
                              ? <>
                                <WarehouseDocumentLabel warehouseDocumentId={document.document.id} number={document.document.number} />
                                <small className="text-muted ml-2">({document.document.externalDocumentNumber})</small>
                              </>
                              : <span>{document.externalNumber}</span>
                          }
                        </div>
                      </div>
                    })}
                  </div>
                </ListGroupItem>
                : <ListGroupItem>
                  <Alert className="mb-0" color="warning">Brak dokumentów w tym okresie</Alert>
                </ListGroupItem>
            }
          </React.Fragment>
      }
    </ListGroup>
  })
};

SynchronizedInfo.propTypes = {

};

export default SynchronizedInfo;
